import React, { useEffect } from "react";
import { Table } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getUsers } from "../features/cutomers/customerSlice";
const columns = [
  {
    title: "SNo",
    dataIndex: "key",
  },
  {
    title: "Name",
    dataIndex: "name",
    sorter: (a, b) => a.name.length - b.name.length,
  },
  {
    title: "Email",
    dataIndex: "email",
  },
  {
    title: "Mobile",
    dataIndex: "mobile",
  },
];

const Customers = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getUsers());
  }, []);
  const customerstate = useSelector((state) => state.customer.customers);
  const data1 = [];
  for (let i = 0; i < customerstate.length; i++) {
    if (customerstate[i].role !== "admin") {
      data1.push({
        key: i + 1,
        name: customerstate[i].firstname + " " + customerstate[i].lastname,
        email: customerstate[i].email,
        mobile: customerstate[i].mobile,
      });
    }
  }

  return (
    <div className="bg-background-light dark:bg-background-dark p-4">
      <h3 className="mb-4 title text-2xl font-bold">Customers</h3>
      <div className="bg-white dark:bg-surface-dark p-2 md:p-4 rounded-xl shadow dark:shadow-gray-800">
        <Table 
          columns={columns} 
          dataSource={data1} 
          scroll={{ x: true }}
          size="small"
          pagination={{
            pageSize: 10,
            responsive: true,
            className: "text-text-light dark:text-text-dark",
          }}
        />
      </div>
    </div>
  );
};

export default Customers;
